export const DEFAULT_DEBOUNCE_DELAY = 500;
